import React from "react";
import { Link } from "gatsby";
import linkedin from "../../assets/images/linkedin.svg";
import facebook from "../../assets/images/facebook.svg";
import twitter from "../../assets/images/twitter.svg";
import github from "../../assets/images/github.svg";
import youtube from "../../assets/images/youtube.svg";
import instagram from "../../assets/images/instagram.svg";
import skype from "../../assets/images/skype.svg";

const Footer = () => {
  const companyLinks = [
    { text: "About Us", url: "/about-us" },
    { text: "Contact Us", url: "/contact-us" },
    { text: "Career", url: "/career" },
    { text: "Case Studies", url: "/case-studies" },
    { text: "Open Source", url: "/open-source" },
    { text: "Blog", url: "/blog/", target: "_blank", newPage: false },
  ];

  const productLinks = [
    { text: "Digital Business Card", url: "/products/laravel-vcards-saas-management-system" },
    { text: "Hospital Management", url: "/products/laravel-hospital-management-system" },
    { text: "POS System", url: "/products/laravel-pos-management" },
    { text: "Custom ChatGPT ChatBot", url: "/products/website-ai-chatbot" },
    { text: "Clinic Management", url: "/products/laravel-clinic-appointment-booking-system" },
    { text: "Documentations", url: "/docs/", target: "_blank", newPage: true },
  ];

  const serviceLinks = [
    { text: "AI Automation Services", url: "/services/ai-automation-services" },
    { text: "Workflow Automation Services", url: "/services/n8n-workflow-automation-services" },
    { text: "Shopify AI Automation Services", url: "/services/shopify-ai-automation-services" },
    { text: "Custom ChatBot Development", url: "/services/chatbot-development-services" },
    { text: "Generative AI Development", url: "/services/generative-ai-development-services" },
    { text: "Laravel Development", url: "/services/laravel-development-services" },
  ];

  const contactLinks = [
    {
      text: "C-303, Atlanta Shopping Mall, Nr. Sudama Chowk, Mota Varachha (Digital Valley), Surat - 394101, Gujarat.",
      url: "#",
      isLink: false,
    },
    { text: " Sales / Product Inquiry: +91 81414 40720", url: "tel:+91 8141440720", isLink: true },
    { text: "Career: +91 70963 36561", url: "tel:+91 7096336561", isLink: true },
    { text: "Email: contact@infyom.in", url: "mailto:contact@infyom.in", isLink: true },
  ];
  const SocialIcon = ({ href, src, alt }) => (
    <a href={href} target="_blank" rel="noreferrer">
      <img
        loading="lazy"
        src={src}
        alt={alt}
        className="w-8 h-8 min-w-8 rounded-full object-cover"
      />
    </a>
  );
  const socialMedia = [
    {
      href: "https://in.linkedin.com/company/infyom-technologies",
      src: linkedin,
      alt: "linkedin",
    },
    { href: "https://www.facebook.com/infyom", src: facebook, alt: "facebook" },
    { href: "https://x.com/infyom", src: twitter, alt: "twitter" },
    { href: "https://github.com/infyomlabs", src: github, alt: "github" },
    {
      href: "https://www.youtube.com/InfyOmTechnologies",
      src: youtube,
      alt: "youtube",
    },
    {
      href: "https://www.instagram.com/infyomtechnologies/",
      src: instagram,
      alt: "instagram",
    },
    { href: "skype:live:infyomtechnologies?chat", src: skype, alt: "skype" },
  ];

  const FooterColumn = ({ title, links, isContactLinks = false }) => {
    return (
      <div className="flex sm:items-start text-start flex-col grow text-base leading-relaxed text-gray-500 font-normal">
        <p className="text-xl font-medium leading-tight text-white">{title}</p>
        {links.map((link, index) =>
          isContactLinks ? (
            <div key={index} className={index === 0 ? "mt-[15px]" : "mt-[7px]"}>
              {link.isLink ? <a href={link.url}>{link.text}</a> : <p>{link.text}</p>}
            </div>
          ) : link.target ? (
            <a
              key={index}
              href={link.url}
              target={link.newPage ? "_blank" : ""}
              className={index === 0 ? "mt-[15px]" : "mt-[7px]"}
            >
              {link.text}
            </a>
          ) : (
            <Link to={link.url} key={index} className={index === 0 ? "mt-[15px]" : "mt-[7px]"}>
              {link.text}
            </Link>
          )
        )}
      </div>
    );
  };

  return (
    <footer className="bg-gray-900">
      <div className="lg:pt-20 sm:pt-16 pt-12 lg:pb-20 sm:pb-16 pb-12 lg:px-7 px-5">
        <div className="container max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-4 xs:grid-cols-2 sm:gap-10 gap-8">
            <FooterColumn title="Company" links={companyLinks} />
            <FooterColumn title="Solutions" links={productLinks} />
            <FooterColumn title="Services" links={serviceLinks} />
            <FooterColumn title="India" isContactLinks links={contactLinks} />
          </div>
        </div>
      </div>
      <div className="self-stretch w-full border-t border-solid border-gray-800  max-md:max-w-full" />
      <div className="pt-[22px] pb-[22px] lg:px-7 px-5">
        <div className="container max-w-7xl mx-auto">
          <div className="flex md:flex-row flex-col md:justify-between justify-center gap-5 w-full">
            <p className="text-base text-gray-500 md:text-start text-center">
              All rights reserved ©2015 - {new Date().getFullYear()} InfyOm Technologies
            </p>
            <div className="flex flex-wrap gap-3 items-center md:justify-end justify-center">
              {socialMedia.map((media, index) => (
                <SocialIcon key={index} href={media.href} src={media.src} alt={media.alt} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
